import { cancelTokenSource } from 'app/utils/axios';
import { Request } from '../utils';

const prefix = 'campaign';
const pharmacyPrefix = 'campaign_pharmacy';

/* GET Campaigns List */
export const getCampaignsList = queries => {
  const { limit, skip, orderBy, sortBy, name, start_date, end_date, status } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!start_date && params.append('start_date', start_date);
  !!end_date && params.append('end_date', end_date);
  !!status && params.append('status', status);

  return Request.get(`${prefix}`, { params, onlyError: true });
};

/* GET Campaign Detail */
export const getCampaignDetail = campaignId => {
  return Request.get(`${prefix}/${campaignId}`, { onlyError: true });
};

/* POST Add Campaign */
export const addCampaign = values => {
  return Request.post(`${prefix}`, values, { handleNotification: true });
};

/* PUT Update Campaign */
export const updateCampaign = (campaignId, values) => {
  return Request.put(`${prefix}/${campaignId}`, values, {
    handleNotification: true,
    cancelToken: cancelTokenSource.token
  });
};

/* PUT Update Campaign Status */
export const updateCampaignStatus = (campaignId, values) => {
  return Request.put(`${prefix}/${campaignId}/status`, values, { handleNotification: true });
};

/*  ---------------------------- Campaign Pharmacy ------------------------------------ */

// GET pharmacy list - not participating in the campaign -- TODO: change with paginated version!!!
export const getNotCampaignPharmacyList = (campaignId, queries) => {
  const { limit, skip, orderBy, sortBy, city_id, district_id, filter } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!city_id && params.append('city_id', city_id);
  !!district_id && params.append('district_id', district_id);
  !!filter && params.append('filter', filter);

  return Request.get(`${pharmacyPrefix}/campaign/${campaignId}`, { params, onlyError: true });
};

// GET Pharmacies participating in the campaign
export const getCampaignPharmacyList = queries => {
  const { limit, skip, orderBy, sortBy, pharmacy_name, campaign_id, city_id, district_id } =
    queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  params.append('campaign_id', campaign_id);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!pharmacy_name && params.append('pharmacy_name', pharmacy_name);
  !!city_id && params.append('city_id', city_id);
  !!district_id && params.append('district_id', district_id);

  return Request.get(`${pharmacyPrefix}`, { params, onlyError: true });
};

// POST - Add campaign to pharmacies
export const addCampaignToPharmacies = (campaignId, values) => {
  return Request.post(`${pharmacyPrefix}/campaign/${campaignId}`, values, {
    handleNotification: true
  });
};

// DELETE Pharmacy Campaign
export const deleteCampaignPharmacy = (campaignId, pharmacyId) => {
  return Request.delete(`${pharmacyPrefix}/campaign/${campaignId}/pharmacy/${pharmacyId}`, {
    handleNotification: true
  });
};
